// todo implement skia-web
// https://shopify.github.io/react-native-skia/docs/getting-started/web/
export const FadeShadow = () => null
